import { render, staticRenderFns } from "./fontTemplate.vue?vue&type=template&id=2250798d&scoped=true&"
import script from "./fontTemplate.vue?vue&type=script&lang=js&"
export * from "./fontTemplate.vue?vue&type=script&lang=js&"
import style0 from "./fontTemplate.vue?vue&type=style&index=0&id=2250798d&prod&lang=scss&"
import style1 from "./fontTemplate.vue?vue&type=style&index=1&id=2250798d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250798d",
  null
  
)

export default component.exports